export const patterns = {
  emailPattern: '([a-zA-Z0-9_.+-]+@[a-zA-Z0-9_.+-]+[.])([a-zA-Z])+(.[a-zA-Z]*)',
  mobNumPattern: '^(?=.*?[1-9])[0-9()-]{10,15}$',
  namePattern: "^[A-Za-z0-9][A-Za-z0-9 _!@#$&()^\\-`.+,\%\"'*-={}|<>?`~]*$",
  localPatten: '[6 - 9]\\d{ 9}',
  numberPattern: '^[0-9]*$',
  textNumber: '^[A-Za-z0-9][A-Za-z0-9 _()]*$',
  textPattern: '^[A-Za-z][A-Za-z _]*$',
  complaintPattern: '^[A-Za-z0-9][A-Za-z0-9 _!@#$&()^\\-`.+,\%\'"*-={}|<>?][^]*$',
  cityPattern: '^[a-zA-Z][A-Za-z ]*$',
  longNamePattern: "^[A-Za-z0-9~`_!@#$&()^\\-`.+,\%\"'*-={}[\]|<>?][A-Za-z0-9 ~`_[\]!@#$&()^\\-`.+,\%\"'*-={}|<>?]*$",
  passwordPattern: "^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-.]).{8,}$",
  addressPattern: "^[A-Za-z0-9][A-Za-z0-9 _@#&()^\\-`.+,\"'*-{}|<>?]*$",
  phone11digitPattern: "^[+]1[0-9]{10}$"

};
